import { render } from "./End.vue?vue&type=template&id=03127455&scoped=true"
const script = {}

import "./End.vue?vue&type=style&index=0&id=03127455&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03127455"]])

export default __exports__